import { enumToOptions } from "../../common/enum/util";

export enum MadoAccountCategoryEnum {
    BALANCE = 'balance',
    OFF_BALANCE = 'offBalance',
    PROFIT_AND_LOSS = 'profitAndLoss',
    CLOSING = 'closing',
    INTERCOMPANY = 'intercompany',
}

export const madoAccountCategoryOptions = enumToOptions(MadoAccountCategoryEnum, 'madoAccount.accountCategoryOptions.');
